import React, { useEffect, useRef, useState } from 'react';
import CustomTitle from '../../../components/UI/title/CustomTitle';
import './style.scss'

import { Helmet } from 'react-helmet';
import MyButton from '../../../components/UI/button/MyButton';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import mixpanel from 'mixpanel-browser';
import useBlockClassName from '../../../hooks/useBlockClassName';
import useMixpanel from '../../../hooks/useMixpanel';

const Home1 = () => {
    const history = useHistory();



    const { trackP1Event } = useMixpanel();

    const [isVisible, setIsVisible] = useState(window.innerWidth > 991);

    function documentFontSize() {
        if (window.innerWidth > 991 && window.innerWidth < 1800) {
            document.documentElement.style.fontSize = 'calc(100vw / 1440)';
            console.log(window.innerWidth)
        } else if (window.innerWidth > 1799) {
            document.documentElement.style.fontSize = '1.2px';
        } else {
            document.documentElement.style.fontSize = '';
        }
    }

    useEffect(() => {
        const handleResize = () => {
            setIsVisible(window.innerWidth > 991);
            documentFontSize();
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        trackP1Event('langing-page-loaded', {})
    }, [])
    

    const handleClick = () => {

        setTimeout(() => {
            trackP1Event('langing-page', {})
            history.push('/stage');
        }, 150);


    }

    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
    const videoRef = useRef(null);

    useEffect(() => {
        const video = videoRef.current;
        if (video) {
            const handleVideoLoad = () => setIsVideoLoaded(true);
            video.addEventListener('loadeddata', handleVideoLoad);

            return () => {
                video.removeEventListener('loadeddata', handleVideoLoad);
            };

        }
    }, []);

    const { updateBlockClassName } = useBlockClassName();

    useEffect(() => {
        updateBlockClassName('home1-block')
    }, [])

    return (
        <>
            {isVisible ? (
                <div className='home1'>
                    <Helmet>

                        <meta name="theme-color" content="#fff"></meta>
                    </Helmet>

                    <div className="home1-content">
                        <div className="home1-left">
                            <div className="home1-left-top">
                                <CustomTitle style={{ marginBottom: "45rem" }} title={'Let AI create UGC videos, eye-catching static ads, and high-performing campaigns'} />
                                <p>Take a <span>3-minute quiz</span> and get a smart
                                    AI-powered promotion plan for your business</p>
                            </div>

                            <div className="hero-featured">

                                <div className="hero-featured-wrapper">
                                    <img src={`${process.env.PUBLIC_URL}/img/forbes-dark.svg`} alt="" />
                                    <img src={`${process.env.PUBLIC_URL}/img/tc-dark.svg`} alt="" />
                                    <img src={`${process.env.PUBLIC_URL}/img/sifted-dark.svg`} alt="" />
                                    <img src={`${process.env.PUBLIC_URL}/img/startaps-dark.svg`} alt="" />
                                </div>
                            </div>
                        </div>
                        <div className="home1-right">

                            <div className="home1-content__img">



                                <video
                                    ref={videoRef}
                                    style={{ width: '100%' }}
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                >
                                    <source src={process.env.PUBLIC_URL + `/video/home/v6-pc.mp4`} type="video/mp4" />
                                </video>

                                {!isVideoLoaded && (
                                    <img src={`${process.env.PUBLIC_URL}/img/home/V6@2x-1-desktop.webp`} alt="" />
                                )}
                            </div>

                            <div style={{ position: 'relative' }}>
                                <MyButton buttonText={'Get started'} buttonStatus={''} onClick={() => handleClick()} />
                                <div className="hand" >
                                    <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_11035_53290)">
                                            <path d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04Z" fill="white"></path>
                                            <path d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04ZM16.573 16.2051C17.1738 15.8582 17.9337 16.0618 18.2805 16.6626L25.1555 28.5705L27.3206 27.3205L24.8206 22.9903C24.4737 22.3895 24.6773 21.6297 25.2781 21.2828C25.8789 20.9359 26.6388 21.1395 26.9857 21.7403L29.4857 26.0705L31.6507 24.8205L29.1507 20.4903C28.8038 19.8895 29.0074 19.1297 29.6083 18.7828C30.2091 18.4359 30.9689 18.6395 31.3158 19.2403L33.8158 23.5705L36.0826 22.2617L34.8326 20.0967C34.4857 19.4958 34.6893 18.736 35.2901 18.3891C35.8899 18.0429 36.6508 18.2458 36.9977 18.8467L41.8808 27.3045C44.0458 31.0544 42.7999 35.704 39.049 37.8696L37.1892 38.9433C35.6033 39.859 33.9059 40.0841 32.2744 39.8857L18.5124 36.2842C17.7525 36.0806 17.4494 35.5556 17.653 34.7957C17.8577 34.0353 18.3817 33.7328 19.1415 33.9364L26.5061 35.9097L16.1155 17.9126C15.7686 17.3118 15.9722 16.552 16.573 16.2051Z" fill="black"></path>
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_11035_53290">
                                                <rect width="40" height="40" fill="white" transform="translate(0 20) rotate(-30)"></rect>
                                            </clipPath>
                                        </defs>
                                    </svg>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            ) : (
                <div className='home1'>
                    <Helmet>

                        <meta name="theme-color" content="#fff"></meta>
                    </Helmet>

                    <div className="home1-content" style={{ flex: '1', display: 'flex', flexDirection: 'column', marginBottom: '32rem' }}>
                        <CustomTitle style={{ marginBottom: "12rem" }} title={'Let AI create UGC videos, eye-catching static ads, and high-performing campaigns'} />
                        <p>Take a <span>3-minute quiz</span> and get a smart<br />
                            AI-powered promotion plan for your business</p>


                    </div>
                    <div className="home1-content__img">



                        <video
                            ref={videoRef}
                            style={{ width: '100%'}}
                            autoPlay
                            loop
                            muted
                            playsInline
                        >
                            <source src={process.env.PUBLIC_URL + `/video/home/v6-mobile.mp4`} type="video/mp4" />
                        </video>

                        {!isVideoLoaded && (
                            <img src={`${process.env.PUBLIC_URL}/img/home/V6-mobile.webp`} alt="" />
                        )}
                    </div>

                    <div style={{ position: 'relative', width: '100%' }}>
                        <MyButton buttonText={'Get started with Zeely'} buttonStatus={''} onClick={() => handleClick()} />
                        <div className="hand" >
                            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clip-path="url(#clip0_11035_53290)">
                                    <path d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04Z" fill="white"></path>
                                    <path d="M15.323 14.04C13.5422 15.0681 12.9223 17.3819 13.9504 19.1626L21.3335 31.9506L20.1934 31.6158L19.7859 31.535C18.8377 31.2832 17.8283 31.4172 16.9787 31.9077C16.129 32.3983 15.5083 33.2054 15.2522 34.1525C15.0004 35.1007 15.1345 36.11 15.625 36.9597C16.1155 37.8093 16.9227 38.4301 17.8697 38.6861L17.8891 38.7197L31.8116 42.3642L31.8981 42.359L31.9711 42.4078C34.2106 42.6893 36.4809 42.2333 38.4381 41.109L40.3 40.034C41.4661 39.3641 42.4883 38.4704 43.3081 37.4043C44.1278 36.3382 44.7289 35.1207 45.0769 33.8217C45.4249 32.5227 45.5129 31.1678 45.3358 29.8347C45.1588 28.5016 44.7202 27.2165 44.0452 26.0534L39.1627 17.5967C38.1346 15.8159 35.8198 15.1966 34.0401 16.2241C33.579 16.4903 33.2256 16.8632 32.9297 17.2707C31.7621 16.0685 29.8684 15.7459 28.3583 16.6177C27.529 17.0965 26.9555 17.8606 26.6813 18.7132C25.7774 18.5142 24.8317 18.6584 24.0281 19.1177C23.6609 19.3359 23.3344 19.6163 23.0631 19.9463L20.4456 15.4126C19.4175 13.6319 17.1038 13.0119 15.323 14.04ZM16.573 16.2051C17.1738 15.8582 17.9337 16.0618 18.2805 16.6626L25.1555 28.5705L27.3206 27.3205L24.8206 22.9903C24.4737 22.3895 24.6773 21.6297 25.2781 21.2828C25.8789 20.9359 26.6388 21.1395 26.9857 21.7403L29.4857 26.0705L31.6507 24.8205L29.1507 20.4903C28.8038 19.8895 29.0074 19.1297 29.6083 18.7828C30.2091 18.4359 30.9689 18.6395 31.3158 19.2403L33.8158 23.5705L36.0826 22.2617L34.8326 20.0967C34.4857 19.4958 34.6893 18.736 35.2901 18.3891C35.8899 18.0429 36.6508 18.2458 36.9977 18.8467L41.8808 27.3045C44.0458 31.0544 42.7999 35.704 39.049 37.8696L37.1892 38.9433C35.6033 39.859 33.9059 40.0841 32.2744 39.8857L18.5124 36.2842C17.7525 36.0806 17.4494 35.5556 17.653 34.7957C17.8577 34.0353 18.3817 33.7328 19.1415 33.9364L26.5061 35.9097L16.1155 17.9126C15.7686 17.3118 15.9722 16.552 16.573 16.2051Z" fill="black"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_11035_53290">
                                        <rect width="40" height="40" fill="white" transform="translate(0 20) rotate(-30)"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>

                </div>
            )}
        </>


    );
}

export default Home1;
